module.exports = __webpack_public_path__ + "static/Placeholder-staff-50ede4b301c63f3ff538d1256161b9c5.jpg";